module.exports = __webpack_public_path__ + "img/deathknight.8657e915.jpg";